/**
 *
 * Asynchronously loads the component for Inbox
 *
 */
import { lazyLoad } from 'utils/loadable';

export const Inbox = lazyLoad(
  () => import('./index'),
  module => module.Inbox,
);
